import { Component, Input, NgZone, OnDestroy } from "@angular/core";
import { ModalDialogComponent } from "src/app/common/modal/modalDialog.component";
import { PendingOrdersFDService, PendingOrdersFDServiceData } from "../../services/pendingOrdersFDKpi/pendingOrdersFD.service";
import { DualSummaryDetailKpiServiceHost } from "src/app/dashboardCommon/components/kpiServiceHostComponent";
import { PendingOrdersFDDetailService, PendingOrdersFDDetailServiceData } from "../../services/pendingOrdersFDKpi/PendingOrdersFDDetail.service";
import { CellStyle, ColumnDefinition, DateColumnDefinition, LinkColumnData, LinkColumnDefinition, RowStyle, TextColumnDefinition } from "src/app/dashboardCommon/components/cardDetails/datatable.component";
import { LoggerService } from "src/app/common/logging/logger.service";
import { ImpersonationService } from "src/app/auth/apigee/impersonation.service";
import { OfficeSelectorService } from "src/app/common/officeSelector/officeSelector.service";
import { PendingOrdersFDKpiCfg, PendingOrdersFDKpiCfgService } from "../../services/pendingOrdersFDKpi/pendingOrdersFDKpiCfg.service";
import { Subscription } from "rxjs";
import moment from 'moment';

export class PendingOrdersFDData {
    public kpi: number;
    public office: number;

    constructor(kpi: number, office: number) {
        this.kpi = kpi;
        this.office = office;
    }
}

export class PendingOrdersFDDetailData {
    public columnDefinitions: ColumnDefinition[];
    public tabledata: any[][];
    public rowStyleSelector: (x) => RowStyle;

    constructor(columnDefinitions: ColumnDefinition[], tabledata: any[][]) {
        this.columnDefinitions = columnDefinitions;
        this.tabledata = tabledata;
        this.rowStyleSelector = (x) => {
            var style = new RowStyle();

            style.cellStyle = [
                new CellStyle(x[3] == "SI" ? "red" : "black", "white", 3),
                new CellStyle(x[4] == "0" ? "green" : "red", "white", 4)
            ];

            return style;
        }
    }
}

@Component({
    selector: 'pending-orders-fd-kpi-service-host',
    template: '<ng-content></ng-content>',
    standalone: false
})
export class PendingOrdersFDKpiServiceHostComponent extends DualSummaryDetailKpiServiceHost<PendingOrdersFDService, PendingOrdersFDServiceData, PendingOrdersFDData, PendingOrdersFDDetailService, PendingOrdersFDDetailServiceData, PendingOrdersFDDetailData> implements OnDestroy {

    public getClassName() { return "PendingOrdersFDKpiServiceHostComponent"; }

    private raasSubscription: Subscription;
    private officeSelectorSubscription: Subscription;
    @Input() public detailDialog: ModalDialogComponent;
    @Input() public messageDialog: ModalDialogComponent;

    constructor(zone: NgZone, logger: LoggerService, private impersonationService: ImpersonationService, private officeSelectorService: OfficeSelectorService, summaryService: PendingOrdersFDService, detailService: PendingOrdersFDDetailService, private serviceCfg: PendingOrdersFDKpiCfgService) {
        super(zone, logger, summaryService, detailService);
        this.raasSubscription = this.impersonationService.impersonationChanged.subscribe(() => { this.resetSummary(); });
        this.officeSelectorSubscription = this.officeSelectorService.selectedOfficeUpdated.subscribe(() => { this.resetSummary(); });
    }

    protected processSummaryData(data: PendingOrdersFDServiceData, updateRequested: boolean): PendingOrdersFDData {
        return new PendingOrdersFDData(data.kpi, data.office);
    }

    protected getDefaultSummaryData(): PendingOrdersFDData {
        let data = new PendingOrdersFDData(0, 0);
        return data;
    }

    protected extractUpdateTime(data: PendingOrdersFDServiceData): Date {
        return data.updateTimestamp;
    }
    protected processDetailData(data: PendingOrdersFDDetailServiceData, args: any): PendingOrdersFDDetailData {

        let columnDefinitions = [
            new TextColumnDefinition("Pedido solicitado", null, false),
            new TextColumnDefinition("Cliente", null, false),
            new DateColumnDefinition("Fecha\ninicio\ncontrato", (data) => {
                let date = moment(data.date).startOf("day");
                if (date.isSame(moment(new Date("0001-01-01T00:00:00")))) {
                    return data.status;
                } else {
                    if (date.isValid()) return date.format("DD/MM/YYYY");
                    else return data.status;
                }
            }, false),
            new LinkColumnDefinition("Pdte. llamamientos", null, false),
            new LinkColumnDefinition("Pdte.\nrealizar\ncontrato", null, false),
            new LinkColumnDefinition("Buscar más candidatos", null, false),
        ];

        let cfg: PendingOrdersFDKpiCfg = this.serviceCfg.getCfg();

        let urlPendingOrdersFD = cfg.urlPendingOrdersFD;

        let tabledata = [];

        (data.pendingOrdersFD || [])
            .forEach(w =>
                tabledata.push([
                    w.requestedJob,
                    w.clienteName,
                    w.ctoBegDate,
                    new LinkColumnData(
                        w.pendingOrderLineFDWorker == 0 ? 'NO' : 'SI',
                        w.pendingOrderLineFDWorker == 0 ? '' : `${urlPendingOrdersFD}${w.orderId}`
                    ),
                    new LinkColumnData(
                        w.pendingContract.toString(),
                        w.pendingContract == 0 ? '' : `${urlPendingOrdersFD}${w.orderId}`
                    ),
                    new LinkColumnData(
                        w.pendingWorkers == 0 ? 'NO' : 'SI',
                        w.pendingWorkers == 0 ? '' : `${urlPendingOrdersFD}${w.orderId}`
                    )
                ]));

        return new PendingOrdersFDDetailData(columnDefinitions, tabledata);
    }

    protected getDefaultDetailData(): PendingOrdersFDDetailData {

        let columnDefinitions = [
            new TextColumnDefinition("Pedido solicitado", null, false),
            new TextColumnDefinition("Cliente", null, false),
            new DateColumnDefinition("Fecha inicio contrato", (data) => {
                let date = moment(data.date).startOf("day");
                if (date.isSame(moment(new Date("0001-01-01T00:00:00")))) {
                    return data.status;
                } else {
                    if (date.isValid()) return date.format("DD/MM/YYYY");
                    else return data.status;
                }
            }, false),
            new LinkColumnDefinition("Pdte. llamamientos", null, false),
            new LinkColumnDefinition("Pdte. realizar contrato", null, false),
            new LinkColumnDefinition("Buscar más candidatos", null, false),
        ];

        return new PendingOrdersFDDetailData(columnDefinitions, []);
    }

    protected performDetailAction(): void {
        if (this.detailDialog) this.detailDialog.open();
    }

    public ngOnDestroy(): void {
        if (this.raasSubscription) this.raasSubscription.unsubscribe();
        if (this.officeSelectorSubscription) this.officeSelectorSubscription.unsubscribe();
    }

    public mergeFilter(filter: any) {
        let detailProcessingArgs = this.detailProcessingArgs || {};
        detailProcessingArgs.filter = detailProcessingArgs.filter || {};
        detailProcessingArgs.filter = { ...detailProcessingArgs.filter, ...filter };
        this.detailProcessingArgs = detailProcessingArgs;
    }
}
